export const ASSET_POLL_INTERVAL_MS = 3000;
export const REPORT_POLL_INTERVAL_MS = 3000;

// The dashboard polls one cheap version token rather than re-running every panel's aggregation,
// so this can be short. React Query pauses intervals while the tab is hidden.
export const DASHBOARD_VERSION_POLL_INTERVAL_MS = 15_000;
